<template>
<v-container class="fill-height data-container" fluid>

    <div id="ag-grid-container">
        <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
            :gridOptions="gridOptions"
            @row-double-clicked="(params) => $emit('edit', params.data.site_id)"
            :groupHeaders="true"
            :rowHeight="40">
        </ag-grid-vue>
    </div>

</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
    name: 'SitesList',
    props: ['sitesList', 'siteResources', 'lockSave', 'savedSiteIndex', 'gridModifications'],
    components: {
        'ag-grid-vue': AgGridVue,
    },
    data: () => ({
        showGrid: false,
        gridOptions: null
    }),

    computed: {

    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.sitesList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
                if(self.$props.savedSiteIndex) {
                    self.gridOptions.api.ensureIndexVisible(self.$props.savedSiteIndex, 'middle');
                }

                if(self.$props.gridModifications) {
                    let gm = self.$props.gridModifications;
                    if(gm.columnState) {
                        self.gridOptions.columnApi.setColumnState(gm.columnState);
                    }
                    if(gm.filterModel) {
                        self.gridOptions.api.setFilterModel(gm.filterModel);
                    }
                    if(gm.sortModel) {
                        self.gridOptions.api.setSortModel(gm.sortModel);
                    }
                }
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'sitesList');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-tres-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.$emit('edit', params.data.site_id);
                        },
                        deleteFunction: (params) => {
                            if(!self.$props.lockSave) {
                                this.$emit('delete', params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Office', 
                    field: 'site_office', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Location', 
                    field: 'site_location', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Site Technician', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.user_id == -1) {
                            return '';
                        }
                        for(let user of self.$props.siteResources.users_list) {
                            if(user.user_id == params.data.user_id) {
                                return user.user_fullname;
                            }
                        }
                    }
                },
                { 
                    headerName: 'Site Name', 
                    field: 'site_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Site Locale', 
                    field: 'site_locale', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Site Type', 
                    field: 'site_type', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.data && params.data.data.site_type) {
                            return params.data.data.site_type;
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Vendor', 
                    field: 'site_vendor', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.data && params.data.data.vendor) {
                            return params.data.data.vendor;
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Network Category', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        let nc = self.$props.siteResources.network_categories.find(nc => params.data.network_category_id == nc.network_category_id);
                        return nc ? nc.network_category_name : "";
                    },
                    cellRenderer: function(params) {
                        if(!params.data.network_category_id) {
                            return;
                        }
                        let networkCategory = self.$props.siteResources.network_categories.find(nc => params.data.network_category_id == nc.network_category_id);
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi ${networkCategory.network_category_icon}" style="color: ${networkCategory.network_category_color}; font-size: 18px;" />
                            <span style="color: #000000; font-size: 12px;">${networkCategory.network_category_name}</span>
                        `;
                        return eElement;
                    },
                    comparator: function(valueA, valueB, paramsA, paramsB) {
                        if(!paramsA.data.network_category_id) {
                            valueA = "";
                        }
                        else {
                            valueA = self.$props.siteResources.network_categories.find(nc => paramsA.data.network_category_id == nc.network_category_id).network_category_name;
                        }
                        if(!paramsB.data.network_category_id) {
                            valueB = "";
                        }
                        else {
                            valueB = self.$props.siteResources.network_categories.find(nc => paramsB.data.network_category_id == nc.network_category_id).network_category_name;
                        }
                        if (valueA == valueB) return 0;
                        return (valueA > valueB) ? 1 : -1;
                    }
                },
                { 
                    headerName: 'Maintenance Window Start', 
                    field: 'maint_start', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Maintenance Window End', 
                    field: 'maint_end', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Num of On-Air Sectors', 
                    field: 'num_on_air_sectors', 
                    width: 150, filter: 'agNumberColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Num of Off-Air Sectors', 
                    field: 'num_off_air_sectors', 
                    width: 150, filter: 'agNumberColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Data Tree Structure', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    valueGetter: function(params) {
                        if(params.data.tree_id == -1) {
                            return '';
                        }
                        for(let tree of self.$props.siteResources.admin_site_book_trees) {
                            if(tree.tree_id == params.data.tree_id) {
                                return tree.tree_name;
                            }
                        }
                    }
                },
            ];
            return columnDefs;
        },

        saveGridModifications: function () {
            TELSA.loading(true);
            let gridState = {
                columnState: this.gridOptions.columnApi.getColumnState(),
                filterModel: this.gridOptions.api.getFilterModel(),
                sortModel: this.gridOptions.api.getSortModel(),
            }
            this.$store.dispatch('setConfigItem', {key: 'sites_grid_state', value: JSON.stringify(gridState)}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        clearGridModifications: function () {
            let colStates = this.gridOptions.columnApi.getColumnState();
            colStates.forEach(c => c.hide = false);
            this.gridOptions.columnApi.setColumnState(colStates);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.$store.dispatch('setConfigItem', {key: 'sites_grid_state', value: ""}).then(response => { });
        }
    },

    watch: {
    },

    mounted() {
        this.buildAgGrid();
    }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
